export class ConfigDB {
	static data = {
		settings: {
			layout_type: 'ltr',
			sidebar: {
				wrapper: 'default',
				bodyWrapper: 'default'
			},
			sidebar_setting: 'default-sidebar',
			sidebar_backround: 'dark-sidebar'
		},
		color: {
			layout_version: 'light',
			color: 'color-1',
			primary_color: 'rgba(0,160,153)',
			secondary_color: '#252752',
			mix_layout: 'default'
		},
		router_animation: 'fadeIn'
	}
}

export default ConfigDB;